import { getMainApi, postMainApi, putMainApi } from "@Shared/utils/ajax";
export const getAgents = async (params = {
  withClients: false
}) => {
  if (params.withClients) {
    return getMainApi({
      clients: true
    }, "/agent");
  }
  return getMainApi({}, "/agent");
};
export const getAgent = async agentUsername => {
  return getMainApi({}, `/agent/${agentUsername}`);
};
export const getAgentClients = async agentUsername => {
  return getMainApi({
    agentUsername
  }, "/client");
};
export const updateAgent = async (details, agentUsername) => {
  return putMainApi(details, `/agent/${agentUsername}`);
};
export const inviteAgent = async details => {
  return postMainApi(details, "/agent/invite");
};
export const updateAgentAccessRights = async (agentUsername, accessRights) => {
  return putMainApi(accessRights, `/agent/${agentUsername}/access-rights`);
};